import * as actions from "./actions";

export default function contentfulReducer(state = [], action) {
    switch (action.type) {

    case actions.GET_CONTENTFUL_SUCCESS:
    case actions.GET_CONTENTFUL_FAIL:
    {
        return action.payload;
    }
    default:
        return state;

    }
}
